export const SET_VARIABLE_CONTEXTES = 'paye-bo/variableContextes/SET_VARIABLE_CONTEXTES'

const initialState = {
  variableContextes: [],
}

export default function variableContexteModule(state = initialState, action) {
  switch (action.type) {
    case SET_VARIABLE_CONTEXTES:
      return { ...state, variableContextes: action.value }
    default:
      return state
  }
}
